import React, { Component } from 'react';
import { Input, Modal, Select, message, Radio } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Option = Select.Option;
const RadioGroup = Radio.Group;

class AddTemplateField extends Component {
    state = {
        visible: false,
        confirmLoading: false,
    }

    show = (type, params) => {
        this.setState({
            type,
            params,
            visible: true,
        }, () => {
            this.props.deep > 1 && this.queryParentDetail();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    queryParentDetail = () => {
        const { params } = this.state;
        const { followBoardTypeId } = params
        const options = {
            method: 'POST',
            url: API_URL.executeMgr.listParentDetail,
            data: {
                followBoardTypeId,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    this.setState({ list: res.data });
                }
            }),
        };
        $.sendRequest(options);
    }

    loopData = (data, posArray, parentId) => {
        data.forEach(item => {
            if (item.followBoardDetailId == parentId) {
                item.rowCol.forEach(pos => {
                    posArray.push(pos);
                });
            } else {
                if (item.children && item.children.length > 0) {
                    this.loopData(item.children, posArray, parentId);
                }
            }
        });
    }

    handleSubmit = () => {
        const { data, deep } = this.props;
        const { type, params } = this.state;
        const { fieldName = '', fieldWebType = '', parentId = 0 } = params;
        if (fieldName.trim() == '') {
            message.warning('请输入字段名称');
            return;
        } else if (fieldWebType == '') {
            message.warning('请选择填写方式');
            return;
        }

        let followBoardDetails = {};
        if (type == 'add') {
            if (parentId && parentId !== '0') {
                let posArray = [];
                this.loopData(data, posArray, parentId);
    
                let len = posArray.length, newData = [...data];
                for (let i = 0; i < len; i++) {
                    const key = posArray[i] - 1;
                    followBoardDetails[`followBoardDetails[${i}].rowSpan`] = newData[key].rowSpan;
                    followBoardDetails[`followBoardDetails[${i}].colSpan`] = newData[key].colSpan + 1;
                    followBoardDetails[`followBoardDetails[${i}].followBoardDetailId`] = newData[key].followBoardDetailId;
                    newData = [...newData[key].children];
                }

                let isContinue = true;
                newData.forEach(item => {
                    if (!isContinue) {
                        return;
                    }
                    if (!item.children || (item.children && item.children.length == 0)) {
                        followBoardDetails[`followBoardDetails[${len}].rowSpan`] = item.rowSpan;
                        followBoardDetails[`followBoardDetails[${len}].colSpan`] = 1;
                        followBoardDetails[`followBoardDetails[${len}].followBoardDetailId`] = '';
                        isContinue = false;
                    }
                })
            } else if (parentId === '0') {
                let rowSpan = 0, newData = [...data];
                for (let i = 0; i < deep; i++) {
                    rowSpan += newData[0].rowSpan;
                    if (newData[0].children && newData[0].children.length > 0) {
                        newData = [...newData[0].children];
                    } else {
                        break;
                    }
                }
                followBoardDetails[`followBoardDetails[0].rowSpan`] = rowSpan;
                followBoardDetails[`followBoardDetails[0].colSpan`] = 1;
                followBoardDetails[`followBoardDetails[0].followBoardDetailId`] = '';
            }
        }

        const url = type == 'add' ? API_URL.executeMgr.addInvestigationFollowDetail : API_URL.executeMgr.editInvestigationFollowDetail;
        const options = {
            method: 'POST',
            url, 
            data: {
                ...params,
                ...followBoardDetails,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.setState({ visible: false }, () => {
                        this.props.loadData();
                    });
                }
            }),
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, field) => {
        const { params } = this.state;
        params[field] = e.target.value;
        this.setState({ params });
    }

    handleSelectChange = (value, field) => {
        const { params } = this.state;
        params[field] = value;
        if (field == 'fieldType') {
            params.fieldWebType = '';
        }
        this.setState({ params });
    }

    handleRadioChange = (e, field) => {
        const { params } = this.state;
        params[field] = e.target.value;
        this.setState({ params });
    }

    getFieldWebType = () => {
        const { params = {} } = this.state;
        const { fieldType = '', fieldWebType = '' } = params;
        if (fieldType == 'TEXT') {
            return (
                <Select
                    value={fieldWebType}
                    placeholder='请选择'
                    style={{ width: 180, marginLeft: 10 }}
                    onChange={(value) => this.handleSelectChange(value, 'fieldWebType')}
                >
                    <Option value='INPUT'>文本框</Option>
                    <Option value='TEXTAREA'>文本域</Option>
                    <Option value='RADIO'>单选</Option>
                    <Option value='CHECKBOX'>多选</Option>
                    <Option value='SELECT'>下拉框</Option>
                </Select>
            );
        } else if (fieldType == 'DATE') {
            return (
                <Select
                    value={fieldWebType}
                    placeholder='请选择'
                    style={{ width: 180, marginLeft: 10 }}
                    onChange={(value) => this.handleSelectChange(value, 'fieldWebType')}
                >
                    <Option value='DATE_YEAR_MONTH_DAY' title="时间控件（年月日）">时间控件（年月日）</Option>
                    <Option value='DATE_YEAR_MONTH'title="时间控件（年月）">时间控件（年月）</Option>
                    <Option value='DATE_YEAR_MONTH_DAY_HOUR_MINUTE' title="时间控件（年月日时分）">时间控件（年月日时分）</Option>
                </Select>
            );
        } else if (fieldType == 'NUMBER') {
            return (
                <Select
                    value={fieldWebType}
                    placeholder='请选择'
                    style={{ width: 180, marginLeft: 10 }}
                    onChange={(value) => this.handleSelectChange(value, 'fieldWebType')}
                >
                    <Option value='INPUTNUMBER'>数值文本框</Option>
                </Select>
            );
        }
    }

    render() {
        const { deep } = this.props;
        const { type, visible, confirmLoading, params = {}, list = [] } = this.state;
        const { parentId, fieldName = '', fieldType = '', fieldIsRequire = '' } = params;
        const parentOptions = list.map(item => <Option key={item.followBoardDetailId} value={item.followBoardDetailId + ''}>{item.fieldName}</Option>)
        return (
            <Modal
                title={type == 'add' ? '添加字段' : '修改字段'}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <ul className="modal-list">
                        {
                            deep > 1 &&
                            <li className="modal-item" style={{paddingBottom: 20}}>
                                <div className="item-left" style={{width: 86, paddingRight: 10}}>字段父层:</div>
                                <div className="item-right">
                                    <Select value={parentId + ''} placeholder='请选择' style={{ width: 180, marginLeft: 10 }} onChange={(value) => this.handleSelectChange(value, 'parentId')}>
                                        {parentOptions}
                                    </Select>
                                </div>
                            </li>
                        }
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>字段名称:</div>
                            <div className="item-right">
                                <Input value={fieldName} placeholder="请输入" style={{ width: 180, marginLeft: 10 }} onChange={e => this.handleInputChange(e, 'fieldName')} />
                            </div>
                        </li>
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>字段类型:</div>
                            <div className="item-right">
                                <Select value={fieldType} disabled={type == 'edit'} style={{ width: 180, marginLeft: 10 }} onChange={(value) => this.handleSelectChange(value, 'fieldType')}>
                                    <Option value="TEXT">文本型</Option>
                                    <Option value="DATE">时间型</Option>
                                    <Option value="NUMBER">数值型</Option>
                                </Select>
                            </div>
                        </li>
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>填写方式:</div>
                            <div className="item-right">
                                { this.getFieldWebType() }
                            </div>
                        </li>
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>是否必填:</div>
                            <div className="item-right">
                                <RadioGroup style={{ marginLeft: 10 }} onChange={e => this.handleRadioChange(e, 'fieldIsRequire')} value={fieldIsRequire}>
                                    <Radio value={'1'}>是</Radio>
                                    <Radio value={'0'}>否</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default AddTemplateField;



// WEBPACK FOOTER //
// ./src/components/executeMgr/template/AddTemplateField.js